<div class="calendar-grid-header">
  <div class="calendar-nav">
    <app-gpd-button
      type="text"
      [text]="labelToday"
      (onClick)="goToToday()"></app-gpd-button>
    <app-gpd-button type="text" icon="arrow-left" [iconSize]="16" (onClick)="prevMonth.emit()"></app-gpd-button>
    <h2 #monthLabelTarget class="calendar-month-label" tabindex="0" role="button"
        (click)="toggleMonthPicker($event)" (keydown.enter)="toggleMonthPicker($event)">{{ monthLabel }}</h2>
    <app-gpd-button type="text" icon="arrow-right" [iconSize]="16" (onClick)="nextMonth.emit()"></app-gpd-button>
    <dx-popover
      [target]="monthLabelTarget"
      [visible]="monthPickerOpen"
      (visibleChange)="$event ? null : closeMonthPicker()"
      [wrapperAttr]="{ class: 'gpd-popover calendar-month-picker-popover' }"
      position="bottom">
      <dx-calendar
        [value]="viewDate"
        zoomLevel="year"
        [minZoomLevel]="'year'"
        [maxZoomLevel]="'year'"
        (onValueChanged)="onMonthPicked($event)">
      </dx-calendar>
    </dx-popover>
  </div>
</div>

<div class="calendar-weekdays">
  <div class="calendar-weekday" *ngFor="let day of weekdayLabels">{{ day }}</div>
</div>

<div class="calendar-days">
  <div
    class="calendar-day"
    *ngFor="let day of calendarDays; trackBy: trackByDay"
    [class.calendar-day-outside]="!day.inCurrentMonth">
    <div class="calendar-day-number" [class.calendar-day-today]="day.isToday">{{ day.date.getDate() }}</div>
    <div class="calendar-day-entries" *ngIf="day.entries.length > 0">
      <div class="calendar-day-entry"
        *ngFor="let entry of visibleDayEntries(day); trackBy: trackByEntryId"
        [ngClass]="entry.chipClass"
        [class.calendar-day-entry-active]="entry.id === selectedEntryId"
        (click)="entryClick.emit(entry)">
        <span class="entry-dot"></span><span class="calendar-day-entry-title">{{ entry.title }}</span>
      </div>
      <div class="calendar-day-entry-more"
        *ngIf="hiddenDayEntryCount(day) as moreCount"
        (click)="openDayAgenda(day, $event)">+{{ moreCount }}</div>
    </div>
  </div>
</div>
